import { ResponseReult } from 'api-base-refrence';
import { filter, map, Observable } from 'rxjs';
import { ISlideshowRepository } from '../../../domain/repository/slideshow.respository';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TFromData } from 'file-upload';
import { AppNestjsResponse } from 'nestjs-model-utility';
import { Slideshow } from '../../../domain/entity/slideshow.entity';
import { SlideShowRequest } from '../../api-client/slide-show.request';

@UntilDestroy()
export class SlideshowRepository implements ISlideshowRepository {
  getSlideshow(): Observable<Slideshow[]> {
    return new SlideShowRequest.List({ limit: 10 }).call().pipe(
      filter((value) => !!value?.response?.data),
      map((value) => value?.response?.data),
      untilDestroyed(this),
    );
  }
  getSlideshowById(id: number): Observable<Slideshow> {
    return new SlideShowRequest.GetById({ id: id }).call().pipe(
      filter((value) => !!value?.response?.data),
      map((value) => value?.response?.data[0]),
      untilDestroyed(this),
    );
  }
  updateSlideshow(
    slideshow: TFromData<Slideshow>,
    id: number,
  ): Observable<ResponseReult<AppNestjsResponse<Slideshow>>> {
    return new SlideShowRequest.Edit({ id: id })
      .setData(slideshow)
      .call()
      .pipe(untilDestroyed(this));
  }
}
